<template>
    <li class="border border-gray-200 rounded-md divide-y divide-gray-200">
        <estimates-old-list-item
            :estimate="latestEstimate"
            :class="hasOtherEstimates ? 'rounded-t-md' : 'rounded-md'"
        ></estimates-old-list-item>
        <ul v-if="opened" class="divide-y divide-gray-200">
            <li v-for="otherEstimate in otherEstimates" :key="otherEstimate.id">
                <estimates-old-list-item
                    :estimate="otherEstimate"
                ></estimates-old-list-item>
            </li>
        </ul>
<!--        <button-->
<!--            v-if="hasOtherEstimates"-->
<!--            class="text-sm text-gray-500 block w-full rounded-b-md px-4 py-1 bg-gray-50 hover:bg-gray-100"-->
<!--            @click="toggle"-->
<!--        >-->
<!--            {{ opened ? 'Hide' : 'View' }} {{ otherEstimates.length }} previous revisions.-->
<!--        </button>-->
    </li>
</template>

<script>
export default {
    props: {
        estimateGroup: Object,
    },
    data () {
        return {
            opened: true,
        }
    },
    computed: {
        latestEstimate () {
            return this.estimateGroup.latestEstimate
        },
        otherEstimates () {
            return this.estimateGroup.otherEstimates
        },
        hasOtherEstimates () {
            return this.estimateGroup.otherEstimates.length > 0
        },
    },
    methods: {
        open () {
            this.opened = true
        },
        close () {
            this.opened = false
        },
        toggle () {
            this.opened ? this.close() : this.open()
        },
    },
}
</script>
